import Form from './form.vue';
import Calculate from './calculate.vue';
import DetailLog from './detail_log.vue';

export { Form, Calculate, DetailLog };
